<template>
    <DataBase class="component-wrap" />
</template>

<script>
import DataBase  from '@/components/view_blocks/Database/Database_wrap';

export default {
  components: {
    DataBase,
  },
};
</script>
